import professionalTermsMarkdownRaw from './termos_profissional_pj.md?raw';

export const PROFESSIONAL_TERMS_MARKDOWN = professionalTermsMarkdownRaw;
